var map = {
	"./busy.mp3": 8226,
	"./dtmf/dtmf-0.mp3": 1021,
	"./dtmf/dtmf-1.mp3": 3592,
	"./dtmf/dtmf-2.mp3": 4735,
	"./dtmf/dtmf-3.mp3": 8122,
	"./dtmf/dtmf-4.mp3": 5353,
	"./dtmf/dtmf-5.mp3": 1988,
	"./dtmf/dtmf-6.mp3": 6427,
	"./dtmf/dtmf-7.mp3": 3398,
	"./dtmf/dtmf-8.mp3": 5749,
	"./dtmf/dtmf-9.mp3": 5472,
	"./dtmf/dtmf-hash.mp3": 2323,
	"./dtmf/dtmf-star.mp3": 7075,
	"./ring.mp3": 9387,
	"./ringback.mp3": 7446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3345;